import React, { useEffect, useState } from "react";
import { fetchAddmoneyLedgers } from "../api/ledgersApi";
import { autoDateFormat } from "../utils/autoDateFormate";
import { formatAmount } from "../utils/formatAmount";
import { useNotify } from "../context/NotifyContext";
import { exportTable, LEDGER_EXPORT_COLUMNS } from "../utils/downloadExcel";
import {
  ListingFilters,
  ListingPagination,
  SortableTh,
  useListingState,
  LEDGER_STATUS_OPTIONS,
} from "./listing";

const AddMoneyLedger = () => {
  const { notify } = useNotify();
  const listing = useListingState({ sortBy: "date", sortDir: "desc" });
  const [totalPages, setTotalPages] = useState(1);
  const [ledgers, setAddmoneyWalletLedger] = useState([]);
  const [totalLedgers, setTotalbyAll] = useState(0);

  const fetch_ledgers = async () => {
    try {
      const result = await fetchAddmoneyLedgers(listing.query);
      if (result?.success) {
        const response = result?.data;
        setAddmoneyWalletLedger(response?.ledgers || []);
        setTotalPages(response?.pagination?.totalPages || 1);
        setTotalbyAll(response?.pagination?.total || 0);
      } else {
        notify(result?.message || "Not Found", "error");
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetch_ledgers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    listing.page,
    listing.limit,
    listing.startDate,
    listing.endDate,
    listing.debouncedSearch,
    listing.sortBy,
    listing.sortDir,
    listing.status,
  ]);

  return (
    <div className="ds-card mt-4 text-xs">
      <ListingFilters
            onClear={listing.clearFilters}
        startDate={listing.startDate}
        endDate={listing.endDate}
        onStartDate={listing.setStartDate}
        onEndDate={listing.setEndDate}
        search={listing.search}
        onSearch={listing.setSearch}
        searchPlaceholder="Search"
        status={listing.status}
        onStatus={listing.setStatus}
        statusOptions={LEDGER_STATUS_OPTIONS}
        showApply
        onApply={fetch_ledgers}
        applyLabel="Search"
        onExport={() =>
          exportTable("add-money-ledger", LEDGER_EXPORT_COLUMNS, ledgers, notify)
        }
      />

      <div className="ds-table-wrap ds-scroll">
        <table className="ds-table ds-table-listing whitespace-nowrap">
          <thead>
            <tr>
              <SortableTh
                label="T. DATE"
                sortKey="date"
                activeKey={listing.sortBy}
                direction={listing.sortDir}
                onSort={listing.toggleSort}
              />
              <th>DESCRIPTION</th>
              <SortableTh
                label="DEBIT (₹)"
                sortKey="debit"
                activeKey={listing.sortBy}
                direction={listing.sortDir}
                onSort={listing.toggleSort}
              />
              <SortableTh
                label="CREDIT (₹)"
                sortKey="credit"
                activeKey={listing.sortBy}
                direction={listing.sortDir}
                onSort={listing.toggleSort}
              />
              <SortableTh
                label="BALANCE (₹)"
                sortKey="closingBalance"
                activeKey={listing.sortBy}
                direction={listing.sortDir}
                onSort={listing.toggleSort}
              />
            </tr>
          </thead>
          <tbody>
            {ledgers?.length > 0 ? (
              ledgers.map((item, index) => (
                <tr key={item?._id || index}>
                  <td>{autoDateFormat(item?.date)}</td>
                  {/* <td>{item?.narration || "Opening Balance"}</td> */}

  <td
                    className="whitespace-nowrap sm:whitespace-nowrap sm:max-w-[220px] sm:truncate cursor-pointer"
                    title={item?.narration || "Opening Balance"}
                  >
                    {item?.narration || "Opening Balance"}
                  </td>


                  {/* <td className="max-w-[200px]">
  <details className="cursor-pointer">
    <summary className="truncate max-w-[200px]" title={item?.narration}>
      {item?.narration || "Opening Balance"}
    </summary>
    <p className="whitespace-normal break-words max-w-[300px] py-2">
      {item?.narration || "Opening Balance"}
    </p>
  </details>
</td> */}

                  <td>{formatAmount(item?.debit)}</td>
                  <td>{formatAmount(item?.credit)}</td>
                  <td>{formatAmount(item?.closingBalance)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center text-[var(--text-muted)]">
                  No Ledgers Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <ListingPagination
        page={listing.page}
        limit={listing.limit}
        total={totalLedgers}
        totalPages={totalPages}
        onPageChange={listing.setPage}
        onLimit={listing.setLimit}
        limitOptions={[10, 20, 50]}
      />
    </div>
  );
};

export default AddMoneyLedger;
